import { useLoaderData, Await } from "react-router-dom"
import { Suspense } from "react"


import RewardsModule from "../components/account/Rewards"
import LoadingWrapperAuth from "../components/common/LoadingWrapperAuth"
import AccountWrapper from "../components/common/AccountWrapper"

const Rewards = () => {
    const data = useLoaderData() 
     
    return <Suspense fallback={<LoadingWrapperAuth text=""/>}>
        <Await resolve={data.data}>
            {() => <>
                <AccountWrapper>
                    <RewardsModule />
                </AccountWrapper>
            </>}
        </Await>
    </Suspense>
}

export default Rewards